<div class="flex flex-col justify-between h-full max-h-[calc(100vh-9rem)] overflow-y-auto" #commentsTabContainer>
  <div *ngIf="comments.length > 0 else emptyState" class="flex flex-col gap-2 overflow-auto mt-1" #commentsContainer>
    @for (comment of comments; track comment._id) {
    <div class="flex flex-col gap-2 py-2 px-1" [ngClass]="{'border-b border-gray-200': !$last}">
      <div class="flex items-start gap-2">
        <div>
        </div>
        <div class="flex flex-col gap-1 w-full min-w-0">
          <div class="flex flex-row items-center gap-1">
            <app-user-name-display [user]="comment.user" [variant]="'avatar-name'">
            </app-user-name-display>
          </div>
          <p class="text-xs text-gray-500"> on {{ comment.createdAt | date:'mediumDate' }} at {{ comment.createdAt |
            date:'hh:mm a' }}</p>
          @if(editCommentId == comment._id) {
          <div class="flex items-center gap-2 w-full">
            <textarea #editCommentInput pTextarea [(ngModel)]="editCommentText" [autoResize]="true"
              placeholder="Type comment here..." (input)="onCommentInput($event, true)"
              (keydown)="onKeyDown($event, true)" class="flex-1 border-none outline-none text-xs px-3 py-2">
              </textarea>
            <app-button icon="pi pi-check" variant="filled" severity="primary" [size]="'sm'" [loading]="isEditingComment" [enableThrottle]="true" (clicked)="editComment(comment)" />
            <app-button icon="pi pi-times" variant="outlined" severity="contrast" [size]="'sm'" (clicked)="closeEditComment()" />
          </div>
          }@else {
          <div class="flex flex-col gap-1">
            <div class="text-sm flex flex-wrap items-center gap-1">
              @if(hasMentions(comment)) {
              @for (mention of getMentionsAsUsers(comment); track mention._id) {
              @if(mention) {
              <span
                class="inline-flex items-center rounded-base bg-gray-200 text-gray-700 px-2 py-0.5 text-[12px] leading-4">
                &#64;{{ mention | fullName }}
              </span>
              }
              }
              }
              <span class="whitespace-pre-wrap break-words w-full">{{ getCommentTextWithoutMentions(comment.comment)
                }}</span>
            </div>
          </div>
          }
          @if(comment.createdAt != comment.updatedAt) {
          <p class="text-xs text-gray-500">(Edited)</p>
          }
        </div>
        @if(currentUser && currentUser._id == comment.user._id) {
        <div class="ml-auto mr-1" (click)="$event.stopPropagation()">
          <app-menu #commentMenu [items]="getCommentMenuItems(comment)">
            <app-icon [type]="'ellipsis-vertical'" [source]="'lucide'" [size]="'sm'"
              (click)="commentMenu.toggle($event)" class="cursor-pointer" />
          </app-menu>
        </div>
        }
      </div>
    </div>
    }
  </div>
  @if (!readonly) {
  <div class="p-2 flex flex-col gap-2 mb-1">
    <div class="flex items-center gap-2 relative">
      @if(showMentionsDropdown && filteredUsers.length > 0) {
      <div
        class="absolute bottom-full mb-1 z-50 bg-white border border-gray-200 rounded-base shadow-lg max-h-48 overflow-y-auto"
        [style.left.px]="mentionsDropdownLeftPosition" [style.width.px]="mentionsWidth">
        @for (user of filteredUsers; track user._id; let i = $index) {
        <div class="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100"
          [class.bg-blue-100]="i === selectedMentionIndex" (click)="selectMention(user, editCommentId ? true : false)">
          <p-avatar [image]="user | userAvatar" shape="circle" [style]="{ width: '2rem', height: '2rem' }" />
          <div>
            <p class="text-sm font-medium">{{ user | fullName }}</p>
            <p class="text-xs text-gray-500">{{ user.email }}</p>
          </div>
        </div>
        }
      </div>
      }
      <p-inputGroup class="relative border border-gray-200 p-1 rounded-base overflow-hidden">
        <input #addCommentInput pInputText [(ngModel)]="addCommentText" placeholder="Type comment here..."
          (input)="onCommentInput($event, false)" (keydown)="onKeyDown($event, false)"
          class="flex-1 border-none outline-none text-xs px-3 py-2" />
      </p-inputGroup>
      <app-button icon="pi pi-send" toolTip="Add Comment" tooltipPosition="top" [loading]="isAddingComment" [enableThrottle]="true" (clicked)="addComment()"
        variant="filled" severity="primary" />
    </div>
  </div>
  }
</div>


<!-- Empty state -->
<ng-template #emptyState>
  <div class="flex items-center justify-center overflow-hidden">
    <div class="mb-40 relative">
      <img [src]="'images/Comment.png' | assetUrl" class="h-[calc(100vh-12rem)] w-full object-cover" />
      <div class="absolute bottom-12 2xl:bottom-28 w-full px-2 text-center">
        <h1 class="text-lg font-semibold text-gray-800">No Comments Yet</h1>
        <p class="text-sm text-gray-500">
          Comments will be shown here once people start collaborating
        </p>
      </div>
    </div>
  </div>
</ng-template>

<app-dialog [visible]="needPermissionDialog" [fullscreenOnMobile]="true" class="max-w-[40rem]"
  (closed)="needPermissionDialog = false">
  <ng-template #headerTemplate>
    <div class="flex items-center gap-2 px-6 py-4 border-b border-gray-200">
      <div class="text-lg font-bold">Someone needs access to this document</div>
      <i class="pi pi-info-circle text-gray-500 text-sm"></i>
    </div>
  </ng-template>
  <ng-template #bodyTemplate>
    <div class="flex flex-col gap-4 justify-between items-center w-full px-6 py-4">
      <div class="flex gap-2 justify-between items-center w-full">
        <p-radioButton [(ngModel)]="selectedAccessOption" value="shareWithPeople" variant="filled"
          class="border-2 rounded-full" (ngModelChange)="onAccessOptionChange('shareWithPeople')" />
        <div class="flex flex-col gap-2 w-full">
          <div class="flex flex-row justify-between items-center">
            <div class="text-md font-medium ml-2">Share with people</div>
            <app-select [(value)]="selectedPermission" [options]="permissionOptions" [config]="permissionConfig" />
          </div>
          <div class="ml-2 mr-2">
            @for (user of needAccessUsers; track user._id) {
            <div class="flex flex-wrap gap-2 items-center">
              <div class="flex rounded-base border p-2 gap-2 items-center">
                <div class="flex gap-2 items-center">
                  <p-avatar [image]="user | userAvatar" shape="circle" [style]="{ width: '2rem', height: '2rem' }" />
                  <div class="flex flex-col">
                    <p class="text-sm font-medium">{{ user | fullName }}</p>
                    <p class="text-xs text-gray-500">{{ user.email }}</p>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      <div class="flex gap-2 justify-between items-center w-full">
        <p-radioButton [(ngModel)]="selectedAccessOption" value="dontShare" variant="filled"
          class="border-2 rounded-full ring-1 ring-gray-200" (ngModelChange)="onAccessOptionChange('dontShare')" />
        <div class="flex flex-col gap-2 w-full">
          <div class="text-md ml-2">Don't share with people</div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <div class="flex justify-end gap-2">
      <app-button label="Cancel" toolTip="Cancel" tooltipPosition="top" (clicked)="needPermissionDialog = false"
        variant="outlined" severity="contrast" />
      <app-button label="Yes, Share" toolTip="Share" tooltipPosition="top" (clicked)="proceedWithComment()"
        variant="filled" severity="primary" />
    </div>
  </ng-template>
</app-dialog>
